import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ToastService } from '../shared/custom-overlay/toast/toast.service';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root'
})

export class UserLoginService implements OnDestroy {

  public forcePwd = false;
  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' });
  metaData: any;
  public userName;
  public $selectedDashboardLabel: BehaviorSubject<any> = new BehaviorSubject({});
  $destroy: Subject<boolean> = new Subject();
  hostlist: string[] = [];


  

  constructor(
    private http: HttpClient,
    private toastService: ToastService,
    private sharedService: SharedService
  ) { }

  getUser(user_id: string, pwd: string, force_login: boolean) {
    this.sharedService.isOrganization = false
    return new Promise(async (resolve, reject) => {
      const request = JSON.stringify({ user_name: user_id, password: pwd, force: force_login })
      await this.http.post<any>(environment.apiUrl + '/userlogin/login/post', request, { headers: this.headers, withCredentials: true })
        .pipe(takeUntil(this.$destroy))
        .toPromise()
        .then((val) => {
          this.sharedService.assent=val.assent
// console.log(val)
          this.sharedService.userId = val.id
          if (val.error) {
            reject(val)
          } else if (val.menuList) {
            this.forcePwd = val.forcePwd;
            this.sharedService.forcePwd = val.forcePwd
            // console.log("Force Password",val.forcePwd)
            if (val.fname)
              this.sharedService.userFName = val.fname;
            if (val.lname)
              this.sharedService.userLName = val.lname;
            this.sharedService.customer = val.customer_name;
            this.sharedService.serviceProviderName = val.service_provider_name
            let changable_menu = {}
            for (let category in val.menuList) {
              // console.log(category,changable_menu.hasOwnProperty(category))
              for (let i = 0; i < val.menuList[category].length; i++) {
                // if(val.menuList[category][i].isSelectable){
                if (changable_menu.hasOwnProperty(category)) {

                  changable_menu[category].push(val.menuList[category][i])
                }
                else {
                  changable_menu[category] = []
                  changable_menu[category].push(val.menuList[category][i])
                }
                // }
                if (val.menuList[category][i].url == 'organization' && val.menuList[category][i].isSelectable) {
                  this.sharedService.isOrganization = true
                  // break
                }
              }
            }
            // for(let category in this.applist){
            //   for(let i=0;i<this.applist[category].length;i++){

            //   }
            // }
            // console.log(changable_menu)
            this.sharedService.menuSubject.next(changable_menu);
            // this._menuSubject.next(val.menuList);
            this.sharedService.$userLogged.next(true)
            resolve(true)
          }
        })
        .catch(err => {
          reject('Something went wrong in the server');
        })
    })
  }

  // getMenu(): Observable<any> {
  //   return this.$menu_array
  // }

  getMetaData(reqobj: any) {
    let request = JSON.stringify(reqobj)
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiUrl + '/app/metadata/get', request, { headers: this.headers })
        .pipe(takeUntil(this.$destroy)).toPromise()
        .then((meta: any) => {
          this.sharedService.moduleNames=meta.commonData.screenMode
          this.metaData = meta;
          // this.sharedService.metaData = meta;
          this.sharedService.metaData = meta
          this.sharedService.metaData = this.formatFactsheetMetaObject(meta);
          this.sharedService.suggestion_rules = meta.commonData.suggestionRules
          this.sharedService.tokens_map_obj = meta.commonData.tokensMap
          this.sharedService.host_plugins = meta.commonData.hostPlugins
          this.sharedService.menu = this.sharedService?.metaData?.apps?.sensor_metadata?.menuList
          // console.log()
          this.getUserPlatform({ "user_name": this.sharedService.userName }).toPromise()
            .then(async (platformList: any) => {
              // console.log(platformList)
              this.sharedService.metaData.commonData.platformOptions = platformList;
              this.sharedService.platform_map = platformList.platformList
              this.sharedService.platform_map.unshift({disp:"All Platforms",type:"all",value:"all"})
              this.sharedService.platform_map = this.sharedService.platform_map.filter(pfobj => pfobj.value !== "user_defined");             
              // Need to remove as per shared service
              this.metaData.commonData.platformOptions = platformList;
              this.sharedService.metaData.commonData.platformOptions.platformList.map((platform: any) => {
                this.sharedService.platformMap[platform.value] = platform.disp;
              })
              // Need to remove as per shared service
              this.metaData.commonData.platformOptions.platformList.map((platform: any) => {
                this.sharedService.platformMap[platform.value] = platform.disp;
              })
              // console.log(this.sharedService.platformMap)
              this.sharedService.platformMap["all"]="All"
              this.getTimerange({ "metakey": "all" }).toPromise()
                .then(async (timerange) => {
                  this.sharedService.timeRange = timerange;
                  await this.getCommonFields({ platform: meta.commonData.platformOptions.default }).toPromise()
                    .then(async (val: any) => {
                      this.sharedService.commonPlatformFields = val.platform_fields;
                      // await this.getHostsList({ platform: meta.commonData.platformOptions.default }).toPromise()
                      //   .then(async (hostlist) => {
                      //     await this.getPerview({ design_name: ["explore_dashboard", "alert_dashboard", "search_dashboard"] }).toPromise()
                      //       .then(dashboard_preview => {
                      //         this.sharedService.dashboard_preview = dashboard_preview;
                      //         if (hostlist.hosts) {
                      //           this.hostlist.length = 0;
                      //           hostlist.hosts.forEach((host: any) => {
                      //             this.hostlist.push(host.value)
                      //           })
                      //           this.sharedService.hostlist = this.hostlist;
                      //         }
                      //         // this.metaData = meta;
                      //         // this.metaData.commonData.platformOptions = platformList;
                      //         // this.metaData.commonData.platformOptions.platformList.map((platform: any) => {
                      //         //   this.platformMap[platform.value] = platform.disp;
                      //         // })
                      //         this.mergeUserMeta();
                      //         this.sharedService.$metaData.next(this.sharedService.metaData)
                      //         this.sharedService.$metaDataUpdated.next(this.sharedService.metaData);
                      //         resolve(true);
                      //       })
                      //   })
                      await this.getPartitionsList({user_name:this.sharedService.userName }).toPromise()
                      .then(async (hostlist) => {
                        this.sharedService.partitions=hostlist
                        this.sharedService.buildPartitionMap()
                        await this.getPerview({ design_name: ["explore_dashboard", "alert_dashboard", "search_dashboard"] }).toPromise()
                          .then(dashboard_preview => {
                            this.sharedService.dashboard_preview = dashboard_preview;
                            if (hostlist.partitions) {
                              this.hostlist.length = 0;
                              hostlist.partitions.forEach((host: any) => {
                                this.hostlist.push(host.value)
                              })
                              this.sharedService.hostlist = this.hostlist;
                            }
                            // this.metaData = meta;
                            // this.metaData.commonData.platformOptions = platformList;
                            // this.metaData.commonData.platformOptions.platformList.map((platform: any) => {
                            //   this.platformMap[platform.value] = platform.disp;
                            // })
                            this.mergeUserMeta();
                            this.sharedService.$metaData.next(this.sharedService.metaData)
                            this.sharedService.$metaDataUpdated.next(this.sharedService.metaData);
                            this.getUserList()
                            .then((userlist)=>{
                              this.sharedService.analystlist = userlist
                              resolve(true);
                            })
                            // resolve(true);
                          })
                      })
                    })
                })
            })
        })
        .catch((err) => {
          reject()
        })
    })
  }

  mergeUserMeta() {
    this.metaData.rule.ruledefault.context.platform = this.metaData.commonData.platformOptions.default;
    this.metaData.alert.alertDefaults.external.platform = this.metaData.commonData.platformOptions.default;
    // Need to remove as per share service
    this.sharedService.metaData.rule.ruledefault.context.platform = this.sharedService.metaData.commonData.platformOptions.default;
    this.sharedService.metaData.alert.alertDefaults.external.platform = this.sharedService.metaData.commonData.platformOptions.default;
  }

  getUserPlatform(reqobj: any) {
    const request = JSON.stringify(reqobj);
    return this.http.post(environment.apiUrl + '/assets/platforms/get', request, { headers: this.headers });
  }

  getTimerange(reqobj: any) {
    const request = JSON.stringify(reqobj);
    return this.http.post(environment.apiUrl + '/common/tdbtimerange/get', request, { headers: this.headers });
  }

  getTimezone(reqobj: any) {
    const request = JSON.stringify(reqobj);
    return this.http.post(environment.apiUrl + '/user/timezone/get', request, { headers: this.headers });
  }

  getUserSecretQuestions(userObj) {
    const request = JSON.stringify(userObj);
    return this.http.post(environment.apiUrl + '/user/secretQtn/get', request, { headers: this.headers });
  }

  sendAuthCode(userObj) {
    const request = JSON.stringify(userObj);
    return this.http.post(environment.apiUrl + '/user/authCode/get', request, { headers: this.headers });
  }

  postSecretQA(verifyObj) {
    const request = JSON.stringify(verifyObj);
    return this.http.post(environment.apiUrl + '/user/secretValue/post', request, { headers: this.headers });
  }

  // postNewpwd(userObj) {
  //   const request = JSON.stringify(userObj);
  //   return this.http.post(environment.apiUrl + '/user/newPwd/post', request, { headers: this.headers });
  // }

  // getUserProfile(reqObj: any) {
  //   let request = JSON.stringify(reqObj);
  //   return this.http.post(environment.apiUrl + '/login/userProfile/get', request, { headers: this.headers });
  // }

  // postUserProfile(myProfileForm: any) {
  //   return this.http.post(environment.apiUrl + '/login/userProfile/post', myProfileForm, { headers: this.headers });
  // }

  // checkOldPassword(password: any) {
  //   return this.http.post(environment.apiUrl + '/userlogin/check/userpwd', JSON.stringify({ user_name: this.userName, password: password }), { headers: this.headers });
  // }

  getHostsList(request: any) {
    return this.http.post<any>(environment.apiUrl + "/assets/hosts/get", request, { headers: this.headers });
  }

  getPartitionsList(request: any) {
    return this.http.post<any>(environment.apiUrl + "/assets/partitions/get", request, { headers: this.headers });
  }

  // postResetPwd(resetPwd: any) {
  //   return this.http.post(environment.apiUrl + '/login/resetPwd/post', resetPwd, { headers: this.headers })
  // }

  // showToaster(msg: string, type: any) {
  //   this.toastService.show({
  //     text: msg,
  //     type: type
  //   })
  // }

  getCommonFields(platform: any) {
    return this.http.post(environment.apiUrl + '/common/platformFields/get', JSON.stringify(platform), { headers: this.headers })
      .pipe(takeUntil(this.$destroy))
  }

  getPerview(reqobj: any) {
    return this.http.post(environment.apiUrl + '/explorelogs/dashboard-preview/get', JSON.stringify(reqobj), { headers: this.headers })
  }

  ngOnDestroy(): void {
    // Need to remove as per shared service
    this.sharedService.menuSubject.unsubscribe()
    this.sharedService.$userLogged.unsubscribe()
    this.$destroy.next(true)
    this.$destroy.unsubscribe()
  }
  formatFactsheetMetaObject(metaObject) {
//console.log(metaObject)
    let tempObject = JSON.parse(JSON.stringify(metaObject))
    metaObject.alert.factsheetMeta.alertUpdateAction.states = tempObject.alert.alertUpdateAction
    // metaObject.alert.factsheetMeta.alertUpdateAction.actions = JSON.parse(JSON.stringify(this.transformData(tempObject.alert.alertUpdateAction)))
    
//console.log(metaObject)
    return metaObject
  }
  transformData(input) {
    const output = {};

    for (const [statusKey, statusValue] of Object.entries(input.status)) {
      if (statusKey != "0") { // Skip the "0" status as per your request,
        // const statusDisp = statusKey == "4" ? statusValue["disp"] : "flagged_for_review"; // Use "Closed" for status "4"
        const statusDisp =  statusValue["disp"]; // Use "Closed" for status "4"
        const stateAction = {};

        for (const [stateKey, stateValue] of Object.entries(statusValue["state"])) {
          const reasons = {};

          for (const [reasonKey, reasonValue] of Object.entries(stateValue["reason"])) {
            reasons[reasonKey] = reasonValue["value"];
          }

          stateAction[stateValue["disp"]] = {
            id: stateKey,
            reason: reasons
          };
        }

        // Add to output (use display name in lowercase, like your sample)
        output[statusDisp.toLowerCase().replace(/\s+/g, "_")] = {
          disp: statusDisp,
          value: parseInt(statusKey, 10),
          state_action: stateAction
        };
      }
    }
    return output;
  }

  getUserList() {
    return new Promise((resolve, reject) => {
      this.getAnalytsList().
        subscribe((data: any) => {
          resolve(data);
        },
          (error) => {
            reject(error);
          })
    })
  }

  getAnalytsList() {
    return this.http.post(environment.apiUrl + '/alerts/analystslist/get', { "user_name": this.sharedService.userName }, { headers: this.headers })
  }
}
//----------------
// this.$metaData.next(this.metaData);
// this.$metaDataUpdated.next(this.metaData);
// this._menuSubject.next(changable_menu);
// this._menuSubject.unsubscribe()
// this.toastService.show({
//----------
// public userLName = "";
// public userFName = "";
// public customer;
// public serviceProviderName;
// private _menuSubject = new Subject<any>();
// $menu_array = this._menuSubject.asObservable();
// $userLogged: BehaviorSubject<boolean> = new BehaviorSubject(false);
// $metaData: Subject<any> = new Subject();
// $metaDataUpdated: BehaviorSubject<any> = new BehaviorSubject({});
// $userLoggedoff: Subject<boolean> = new Subject();
// userLoggedoff_ = this.sharedService.$userLoggedoff.asObservable();
// $customerChanged: Subject<any> = new Subject();
// customerChanged_ = this.$customerChanged.asObservable();
// timezone: string;
// timerange: any;
// platformMap = {};
// dashboard_preview: any = null;
// commonPlatformFields: any[] = [];
// already_login_warning_msg = "An active session exists. Would you like to terminate that session?";
// previewRef;
// mat_spinner_login_state: boolean = false;
// isOrganization: boolean = false
